import { Component, OnInit , ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, ToastController, Platform } from '@ionic/angular';
import { UserService } from '../services/user.service';
import { SharedService } from '../services/shared.service';

@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
})
export class HomePage implements OnInit{
  notificationData:any;
  badgeData: any;
  badgeCount = null;
  loginText = 'KUNDEN LOGIN';
  subscription: any;
  unreadCount = 0;

  constructor(
    private router:Router,
    public alertController: AlertController,
    public toastController: ToastController,
    private platform: Platform
  ) {
  }
  
  ionViewWillEnter(){
    this.subscription = this.platform.backButton.subscribe(()=>{ 
      navigator['app'].exitApp(); 
    }); 
    if(localStorage.getItem('auth_token')){
      this.loginText = 'PERSÖNLICHER BEREICH';
    }else{
      this.loginText = 'KUNDEN LOGIN';
    }
  }

  ionViewWillLeave(){ 
    this.subscription.unsubscribe(); 
  }


  ngOnInit() {}

  async presentToast(msg) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 3000,
      position: 'top',
    });
    toast.present();
  }

  login(){    
    this.router.navigate(['customer-login']);   
  }
}
